/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS14 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_13;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_14;
    },
    getDownloadName() {
      return ns.IOS14.nice_name;
    },
  });

  Object.assign(IOS14, {
    slug: `ios_14`,
    nice_name: `iOS 14 adoption`,
    description: `How quickly are consumers upgrading to iOS 14?`,
  });
  ns.IOS14 = IOS14;
});

}.call(window));